import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import { selectAppPersistOnBoardStart } from '@store/useAppStorePersist';

import style from './style.module.scss';

const DescriptionSkeleton = () => {
  const { t } = useTranslation();

  const onBoard = selectAppPersistOnBoardStart();

  return (
    <div className={style.block}>
      <div className={style.blockHead}>
        <div className={style.blockTitle} id="tourStep-14">
          {t('What We are Seeing')}
        </div>
      </div>
      <div className={cx(style.blockContainer, { [style.onBoardBlockHide]: onBoard })}>
        <div className={style.skeletonDescriptionInfoWrapper}>
          <SkeletonBlock className={style.skeletonDescriptionTitle} />
          {[...Array(3)].map((_) => (
            <SkeletonBlock key={uuidv4()} className={style.skeletonDescriptionInfo} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DescriptionSkeleton;
